import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { FormGroupControl } from '@components/Base';

const GROUP_PROPS = { className: 'mb-3' };

const ClaimCardBody = () => {
  const { t } = useTranslation();

  return (
    <Card.Body>
      <Card.Title>{t('common:claim')}</Card.Title>
      <Row>
        <Col>
          <FormGroupControl
            type="datetime-local"
            name="accidentHappenedAt"
            label={t('healthInsuranceClaimForm.accidentHappenedAt.label')}
            required
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl
            required
            multiple
            type="file"
            name="supportingDocuments"
            label={t('claimForm.supportingDocuments.label')}
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl
            required
            name="totalClaimedAmount"
            label={t('claimForm.totalClaimedAmount.label')}
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
    </Card.Body>
  );
};

export { ClaimCardBody };
